// extracted by mini-css-extract-plugin
export var createdDate = "_ld-1";
export var divider = "_ld-2";
export var headerDivider = "_ld-3";
export var messagesCard = "_ld-0";
export var messagesContainer = "_ld-6";
export var messagesContainerWrapper = "_ld-4";
export var showLeftPanelButton = "_ld-8";
export var topButtons = "_ld-7";
export var withPadding = "_ld-5";